// extracted by mini-css-extract-plugin
export default {"error_message":"Header_error_message__sL2Xr"};